module.exports = __webpack_public_path__ + "static/media/capisso.69fb62b6.png";